/**
 * @param {筛选完成后回调} okCallback {回调参数：cityNames, categoryIDs, lableIDs, provinceName}
 */
function ProductFilter(okCallback) {
  var _this = this;
  //产品分类
  $(".pc-product-filter-panel div .product-categorys div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductCategoryItem(index, ".pc-product-filter-panel div .product-categorys div");
    });
  });
  // 产品标签
  $(".pc-product-filter-panel div .product-labels div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductLabelItem(index, ".pc-product-filter-panel div .product-labels div");
    });
  });
  //产地筛选
  $(".pc-product-filter-panel div .product-provinces div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductProvinceItem(index, ".pc-product-filter-panel div .product-provinces div");
    });
  });
  this.okCallback = okCallback;
  this._bindCityItemClickEvent();
}
ProductFilter.prototype = {
  _onClickedOk : function() {
    var citys = this.extractCityNames();
    var productCategorys = [];
    var productLabels = [];
    var bIsProductListPage = $(".pc-product-filter-panel div .product-citys div").length > 0;
    if (bIsProductListPage) 
    {
      productCategorys = this.extractProductCategoryIDs().categoryIDs;
      productLabels = this.extractProductLabelIDs().labelIDs;
    }
    var strProvince = this.extractProvinceName();   
    if (this.okCallback)
    {
      this.okCallback(citys, productCategorys, productLabels, strProvince);
    }

    this._serializeCitys();
    this._serializeSelectedProvince();
    this._serializeSelectedProductCategory();
    this._serializeSelectedProductLabel();
  },
  /**
   * 产品分类项选择
   * @param {左侧菜单索引} index 
   * @param {产品分类项选择器} selectorPath 
   */
  _onClickedProductCategoryItem : function(index, selectorPath){
    if (index == 0) {
      $(selectorPath).eq(index).addClass("tag-checked").siblings().removeClass("tag-checked");
    }
    else {
      if ($(selectorPath).eq(index).attr("class")) {
        $(selectorPath).eq(index).removeClass("tag-checked");
        if ($(selectorPath + ".tag-checked").length == 0) {
            $(selectorPath).eq(0).addClass("tag-checked");
        }
      }
      else {
        $(selectorPath).eq(index).addClass("tag-checked");
        $(selectorPath).eq(0).removeClass("tag-checked");
      }
    }
    this._onClickedOk();
  },
  /**
   * 产品标签项选择
   */
  _onClickedProductLabelItem : function(index, selectorPath){
      this._onClickedProductCategoryItem(index, selectorPath);
  },
  /**
   * 省份项选择
   */
  _onClickedProductProvinceItem : function(index, selectorPath){
      if ($(selectorPath).eq(index).attr("class")) 
      {
          return;
      }
      // 清除城市列表
      var strCityElementRootPath = ".pc-product-filter-panel div .product-citys";
      $(strCityElementRootPath).html('');
      // 选中当前选择的省份
      $(selectorPath).eq(index).addClass("tag-checked").siblings().removeClass("tag-checked");

      var strProvince = this.extractProvinceName();
      if (index > 0) 
      {
          var _this = this;
          this._requestCityList(function (bResult, datas){
              if (bResult){
                  _this._appendCitysToDOM(datas);
              }
              _this._onClickedOk();
          }, strProvince);
      } else if (index === 0) {
          this._onClickedOk();
      }
  },
  /**
   * 城市项选择
   */
  _onClickedProductCityItem : function(index, selectorPath){
  },
  /**
   * 提取当前选择的产品分类
   * @returns : [id]
   */
  extractProductCategoryIDs : function() {
    const strElementCategoryItemPath = ".pc-product-filter-panel div .product-categorys div.tag-checked";
    var categoryIDs = [];
    const categoryNames = [];
    $(strElementCategoryItemPath).each(function (index) {
      const id = $(this).attr("id") || '';
      if (id.length > 0) {
        categoryIDs.push(id);
        const title = $(this).text() || '';
        categoryNames.push(title);
      }
    });
    return {categoryIDs, categoryNames};
  },
  /**
   * 提取当前选择的产品标签
   * @returns : [id]
   */
  extractProductLabelIDs : function() {
      const strElementLabelItemPath = ".pc-product-filter-panel div .product-labels div.tag-checked";
      const labelIDs = [];
      const labelNames = [];
      $(strElementLabelItemPath).each(function (index) {
        const id = $(this).attr("id") || '';
        if (id.length > 0) {
          labelIDs.push(id);
          const title = $(this).text() || '';
          labelNames.push(title);
        }
      });
      return {labelIDs, labelNames};
  },
  /**
   * 提取当前选择的产地
   * @returns : string
   */
  extractProvinceName : function() {
      var strProvince = $(".pc-product-filter-panel div .product-provinces div.tag-checked").text();
      if (!strProvince || strProvince.length == 0 || strProvince == "全选") 
      {
          strProvince = "";
      }
      return strProvince;
  },
  /**
   * 提取当前选择的城市
   * @returns : [string]
   */
  extractCityNames : function() {
      var citys = [];
      const strElementCityPath = ".pc-product-filter-panel div .product-citys div";
      var strProvince = $(".pc-product-filter-panel div .product-provinces div.tag-checked").text();
      if (strProvince) 
      {
          if (strProvince != "全选") 
          {
              if ($(strElementCityPath + ".tag-checked").length > 0)
              {
                  $(strElementCityPath + ".tag-checked").each(function (index){
                      var strCity = $(this).text();
                      if (strCity)
                      {
                          citys.push(strCity);
                      }
                  });
              }
          }
      }
      return citys;
  },
  /**
   * 保存当前加载的城市 和 选择的城市索引
   */
  _serializeCitys : function(){
    var arrCitys = [];
    var arrSelectedCityIndexs = [];
    var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .city li");
    elementCitys.each(index => {
      var strCity = elementCitys.eq(index).text();
      arrCitys.push(strCity);
      if (elementCitys.eq(index).attr("class") == "checked"){
        arrSelectedCityIndexs.push(index);
      }
    });
    this.arrCitys = arrCitys;
    this.arrSelectedCityIndexs = arrSelectedCityIndexs;
  },
  /**
   * 保存当前选择的省份索引
   */
  _serializeSelectedProvince : function (){
      var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .province li");
      var that = this;
      elementCitys.each(index => {
          if (elementCitys.eq(index).attr("class") == "checked"){
              that.nCurSelectedProvinceIndex = index;
          }
      });
  },
  /**
   * 保存当前选择的产品分类索引
   */
  _serializeSelectedProductCategory : function (){
      var elementCategoryItems = $(".product-filter .product-filter-content .right-submenu .product-categorys li");
      if (elementCategoryItems.length > 0)
      {
          var arrSelectedIndexs = [];
          elementCategoryItems.each(index => {
              if (elementCategoryItems.eq(index).attr("class") == "checked"){
                  arrSelectedIndexs.push(index);
              }
          });
          this.arrSelectedProductCategoryIndexs = arrSelectedIndexs;
      }
  },
  /**
   * 保存当前选择的产品标签索引
   */
  _serializeSelectedProductLabel : function (){
    var elementLabelItems = $(".product-filter .product-filter-content .right-submenu .product-labels li");
    if (elementLabelItems.length > 0)
    {
      var arrSelectedIndexs = [];
      elementLabelItems.each(index => {
        if (elementLabelItems.eq(index).attr("class") == "checked"){
          arrSelectedIndexs.push(index);
        }
      });
      this.arrSelectedProductLabelIndexs = arrSelectedIndexs;
    }
  },
  _deserializeCitys : function(){
      this._appendCitysToDOM(this.arrCitys);

      var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .city li");
      this.arrSelectedCityIndexs.forEach(index => {
          elementCitys.eq(index).addClass("checked");
      });
  },
  _deserializeSelectedProvine : function(){
      var elementProvinces = $(".product-filter .product-filter-content .right-submenu .product-places .province li")
      elementProvinces.eq(this.nCurSelectedProvinceIndex).addClass("checked").siblings().removeClass("checked");
  },
  _deserializeSelectedProductCategory : function(){
      var elementCategoryItems = $(".product-filter .product-filter-content .right-submenu .product-categorys li");
      if (elementCategoryItems.length > 0)
      {
          this.arrSelectedProductCategoryIndexs.forEach(index => {
              elementCategoryItems.eq(index).addClass("checked");
          });
      }
  },
  _deserializeSelectedProductLabel : function(){
    var elementLabelItems = $(".product-filter .product-filter-content .right-submenu .product-labels li");
    if (elementLabelItems.length > 0)
    {
      this.arrSelectedProductLabelIndexs.forEach(index => {
        elementLabelItems.eq(index).addClass("checked");
      });
    }
  },
  /**
   * 动态向产地子级列表中添加内容
   * @param   
   *      citys: [string]
   */
  _appendCitysToDOM : function(citys) {
      var cityElement = $(".pc-product-filter-panel div .product-citys")
      if (cityElement.length > 0)
      {
          // 手机端 城市数据填充
          cityElement.html('');
          if (citys) 
          {
              if (!Array.isArray(citys)) 
              {
                  citys = [citys];
              }
              citys.forEach(function (city){
                  if (city) 
                  {
                      var htmlText = '<div>' + city + '</div>';
                      cityElement.append(htmlText);
                  }
              });
              this._bindCityItemClickEvent();
          }
      }    
  },
  /**
   * 绑定二级行政区点击事件
   */
  _bindCityItemClickEvent : function() {
      const _this = this;
      var strParentElementPath = ".pc-product-filter-panel div .product-citys div";
      if ($(strParentElementPath).length > 0){
          $(strParentElementPath).each(function (index) {
              $(this).click(function () {
                  if ($(strParentElementPath).eq(index).attr("class")) {
                      $(strParentElementPath).eq(index).removeClass("tag-checked");
                  }
                  else {
                      $(strParentElementPath).eq(index).addClass("tag-checked");
                  }
                  _this._onClickedOk();
              });
          });       
      }
  },
  /**
   * 获取指定省份下的城市
   * @param {*} strProvince 
   * @param {数据加载成功后回调} fn ：【fn(bResult, datas), datas:[string]】
   */
  _requestCityList : function(fn, strProvince = "") {
      $.ajax({
          type:'POST',
          url: '/base/region',
          data:{
              "province":strProvince
          },
          success:function (response){
              if (response && (response.errno == 0) && response.data){                
                  fn(true, response.data);
              }
              else {
                  fn(false, response.data);
              }
          }
      } );
  },

  // 重置当前选择的项
  reset: function() {
    $('.pc-product-filter-panel div .product-categorys div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
    $('.pc-product-filter-panel div .product-labels div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
    $('.pc-product-filter-panel div .product-provinces div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
  }
}

module.exports.ProductFilter = ProductFilter;
